import { Component, Input, OnInit } from '@angular/core';
import { ClientsService } from 'app/modules/shared/services/clients.service';
import { CurrentUserStateService } from 'app/modules/shared/services/current-user-state.service';
import { ImpersonationService } from 'app/modules/shared/services/impersonation.service';

@Component({
    selector: 'app-product-menu',
    templateUrl: './product-menu.component.html',
    styleUrls: ['./product-menu.component.scss'],
})
export class ProductMenuComponent implements OnInit {
    @Input() showProductMenu: boolean;
    @Input() isExpanded: boolean;
    compensafeUrl: string;
    usMorgageUrl: string = 'https://simplenexus.com/login';
    enterProductMenu: boolean;

    constructor(
        private currentUserStateService: CurrentUserStateService,
        private clientService: ClientsService,
        private impersonationService: ImpersonationService
    ) {}

    ngOnInit(): void {
        let clientShortName = this.currentUserStateService.currentUser.clientShortName;
        if (this.impersonationService.isImpersonatingClient()) {
            clientShortName = this.impersonationService.impersonateClient;
        }
        this.clientService.getClientCSUrl(clientShortName).subscribe((data) => {
            this.compensafeUrl =
                data.compenSafeUrl ?? 'https://www.ncino.com/mortgage/us/incentive-compensation';
        });
    }

    mouseenter(event) {
        this.enterProductMenu = true;
    }

    mouseleave(event) {
        this.enterProductMenu = false;
    }
}
